import { render, staticRenderFns } from "./addChannels.vue?vue&type=template&id=4fad3e0f&"
import script from "./addChannels.vue?vue&type=script&lang=js&"
export * from "./addChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports